export default __webpack_public_path__ + "static/media/icon-GMX.195e3c0f.svg";